import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseFieldItem } from '../../store/models/field-models';

@Injectable({
    providedIn: 'root',
})
export class FieldUtilsService {
    constructor(private translate: TranslateService) {}

    getPlaceholder(field: BaseFieldItem): string {
        if (!field.placeholder) {
            return '';
        }

        if (field.placeholder && field.placeholderSuffix) {
            return `${this.translate.instant(field.placeholder)} (${field.placeholderSuffix})`;
        }

        return this.translate.instant(field.placeholder);
    }
}
